import { jsx as _jsx } from "react/jsx-runtime";
import { useDataActions } from '../../hooks/useDataActions';
import { VanillaReviewerCheckbox } from './Vanilla';
const ReviewerCheckbox = (props)=>{
    const { regvar, ...rest } = props;
    const dataActions = useDataActions();
    const onChange = (value, e)=>{
        props.onChange && props.onChange(value, e);
        dataActions.updateRow((row)=>row.setRegvarInclude(regvar.$rcc.shortname, value));
    };
    return /*#__PURE__*/ _jsx(VanillaReviewerCheckbox, {
        ...rest,
        value: regvar.include,
        onChange: onChange
    });
};
export default ReviewerCheckbox;
